<template>
  <div class="attr-list">
    <el-form>
      <el-form-item label="标题字体大小">
        <el-input-number v-model="curComponent.style.fontSize" />
      </el-form-item>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
      <template v-if="curComponent.componentType === 'AttendanceRate'">
        <el-form-item label="考勤标题字体大小">
          <el-input-number v-model="curComponent.style.titleFontSize" />
        </el-form-item>
        <el-form-item label="考勤率字体大小">
          <el-input-number v-model="curComponent.style.rateFontSize" />
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  }
}
</script>
